import { afterNextRender, ChangeDetectionStrategy, Component, inject, signal, PLATFORM_ID } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { isPlatformBrowser } from '@angular/common';
import { LANG_SIGNAL } from '@lyricstream/shared';
import { scrollToSection } from '../../../core/utils/scroll-to-section';

@Component({
  selector: 'app-conditions',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, RouterLink],
  templateUrl: './conditions.html',
  styleUrl: './conditions.scss',
})
export class ConditionsComponent {
  private readonly platformId = inject(PLATFORM_ID);

  protected readonly lang = inject(LANG_SIGNAL);

  protected readonly sections = [
    { id: 'a1', label: 'Objet du service' },
    { id: 'a2', label: 'Acceptation' },
    { id: 'a3', label: 'Compte utilisateur' },
    { id: 'a4', label: 'Contributions' },
    { id: 'a5', label: "Droits d'auteur" },
    { id: 'a6', label: 'Usage acceptable' },
    { id: 'a7', label: 'Abonnement Premium' },
    { id: 'a8', label: 'Modération' },
    { id: 'a9', label: 'Responsabilité' },
    { id: 'a10', label: 'Modifications' },
    { id: 'a11', label: 'Droit applicable' },
  ];

  protected readonly activeSection = signal('a1');
  protected readonly year = new Date().getFullYear();

  /** Lien du sommaire : défilement direct (le défilement du routeur ne se déclenche pas, cf. scrollToSection). */
  protected goTo(id: string, event: Event): void {
    event.preventDefault();
    if (scrollToSection(id)) this.activeSection.set(id);
  }

  constructor() {
    afterNextRender(() => {
      if (!isPlatformBrowser(this.platformId)) return;

      // Arrivée avec une ancre dans l'URL (lien partagé) : on y défile.
      const initial = window.location.hash.slice(1);
      if (initial) scrollToSection(initial);

      const headings = document.querySelectorAll<HTMLElement>('.legal-body h2[id]');
      const observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (entry.isIntersecting) {
              this.activeSection.set(entry.target.id);
            }
          }
        },
        { rootMargin: '-80px 0px -60% 0px' },
      );
      headings.forEach((h) => observer.observe(h));
    });
  }
}
